// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"a411c95e","805":"a48d0401"}[chunkId] + ".chunk.css";
};